import { Event } from "../../contracts";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const filterExpiredOutrights = (x: Event) => {
    if (x.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() && !x.isLive && new Date(x.startEventDate) <= new Date()) {
        return false;
    }

    return true;
};